import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { message } from "antd";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";

function BookCar() {
  const location = useLocation();  // ✅ Get the passed vehicle data
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [pickTime, setPickTime] = useState("");
  const [dropTime, setDropTime] = useState("");

  const vehicle = location.state?.vehicle;  // ✅ Extract vehicle data from state

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("passengerData"));
    if (storedUser) setUser(storedUser);
  }, []);

  const handleReservation = async (e) => {
    e.preventDefault();

    if (!user) {
      message.warning("You must be logged in to reserve a car.");
      navigate("/signin");
      return;
    }

    if (!pickTime || !dropTime) {
      message.error("Please fill in both pick-up and drop-off dates.");
      return;
    }

    try {
      await axios.post("http://93.127.203.113:5005/reservations", {
        passengerId: user.id,
        vehicleId: vehicle.id,
        agreementId: null,
        price: vehicle.vehicle_type.pricePerKM,
        startDate: pickTime,
        endDate: dropTime,
        status: "pending"
      });

      message.success("Reservation successful!");
      navigate("/"); // ✅ Redirect to home or confirmation page after success
    } catch (error) {
      message.error("Failed to submit reservation. Please try again.");
    }
  };

  if (!vehicle) {
    return <h2>No vehicle selected. Please choose a car.</h2>;
  }

  return (
    <>
      <section className="book-car-page">
        <HeroPages name="Book Your Car" />
        <div className="container">
          <div className="booking-main">
            {/* Left Section: Car Details */}
            <div className="booking-main__img-wrapper">
              <img
                className="booking-main__img"
                src={`http://93.127.203.113:5005${vehicle.vehicleImage}`}
                alt={vehicle.model}
              />
            </div>

            {/* Right Section: Booking Form */}
            <div className="booking-main__text">
              <h2 className="booking-main__title">Reserve Your Car</h2>
              <h3 className="booking-main__subtitle">{vehicle.model}</h3>

              <div className="car-info">
                <p><strong>Type:</strong> {vehicle.vehicle_type.typeName}</p>
                <p><strong>Plate:</strong> {vehicle.plateNumber}</p>
                <p><strong>Price:</strong> Br{vehicle.vehicle_type.pricePerKM} / day</p>
              </div>

              <form onSubmit={handleReservation} className="booking-form">
                <label>Pick-Up Date <b>*</b></label>
                <input type="date" value={pickTime} onChange={(e) => setPickTime(e.target.value)} required />

                <label>Drop-Off Date <b>*</b></label>
                <input type="date" value={dropTime} onChange={(e) => setDropTime(e.target.value)} required />

                <button type="submit" className="reserve-btn">Confirm Reservation</button>
                <button type="button" onClick={() => navigate("/models")} className="close-btn">Cancel</button>
              </form>
            </div>
          </div>
        </div>

        <Footer />
      </section>

      {/* ✅ Styles */}
      <style jsx>{`
        .book-car-page {
          width: 100%;
          padding: 80px 20px;
          background-color: #f8f9fa;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .booking-main {
          display: flex;
          gap: 40px;
          align-items: center;
          justify-content: center;
        }

        .booking-main__img-wrapper {
          width: 45%;
          border-radius: 10px;
          overflow: hidden;
        }

        .booking-main__img {
          width: 100%;
          height: auto;
          border-radius: 10px;
        }

        .booking-main__text {
          width: 50%;
          background: white;
          padding: 30px;
          border-radius: 12px;
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
        }

        .booking-main__subtitle {
          font-size: 1.8rem;
          color: #0c8c49;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 10px;
        }

        .booking-main__title {
          font-size: 3rem;
          color: #333;
          margin-bottom: 15px;
        }

        .car-info {
          font-size: 1.6rem;
          color: #555;
          line-height: 1.8;
          margin-bottom: 20px;
        }

        .booking-form {
          display: flex;
          flex-direction: column;
        }

        .booking-form label {
          font-size: 14px;
          font-weight: bold;
          color: #333;
          margin-bottom: 5px;
        }

        .booking-form input {
          width: 100%;
          padding: 12px;
          font-size: 14px;
          border: 2px solid #ddd;
          border-radius: 8px;
          margin-bottom: 15px;
          transition: border 0.3s;
        }

        .booking-form input:focus {
          border-color: #0c8c49;
          outline: none;
        }

        .reserve-btn {
          width: 100%;
          padding: 12px;
          font-size: 16px;
          font-weight: bold;
          color: white;
          background-color: #0c8c49;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.3s;
        }

        .reserve-btn:hover {
          background-color: #09733a;
        }

        .close-btn {
          width: 100%;
          padding: 12px;
          font-size: 16px;
          font-weight: bold;
          color: white;
          background-color: #d9534f;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.3s;
          margin-top: 10px;
        }

        .close-btn:hover {
          background-color: #c9302c;
        }

        @media (max-width: 1024px) {
          .booking-main {
            flex-direction: column;
            text-align: center;
          }

          .booking-main__img-wrapper {
            width: 80%;
          }

          .booking-main__text {
            width: 80%;
          }
        }

        @media (max-width: 768px) {
          .booking-main__title {
            font-size: 2.5rem;
          }

          .booking-form input {
            font-size: 1.5rem;
          }
        }
      `}</style>
    </>
  );
}

export default BookCar;
